"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.fetchDealerId = exports.formatID = void 0;
const dealer_context_service_1 = require("./dealer-context-service");
const helper_1 = require("./helper");
const getDealerIdFromDocument = () => {
    return helper_1.getMetaContent(document.head, dealer_context_service_1.DEALER_ID_META_ATTRIBUTE) || null;
};
const formatID = (dealerId) => {
    var _a;
    if (dealerId) {
        const parsedDealerId = dealerId.length > 5 ? dealerId.substring(dealerId.length - 5, dealerId.length) : dealerId;
        const parsedMarket = dealerId.length > 5
            ? dealerId.substring(0, 3)
            : (_a = window.SETUPS) === null || _a === void 0 ? void 0 : _a.get('nemo.locale.country.iso3');
        return {
            brand: 'A',
            id: parsedDealerId,
            market: parsedMarket,
        };
    }
    return null;
};
exports.formatID = formatID;
const fetchDealerId = () => __awaiter(void 0, void 0, void 0, function* () {
    return new Promise((resolve) => {
        const dealerIdFromDocument = getDealerIdFromDocument();
        if (dealerIdFromDocument) {
            return resolve(exports.formatID(dealerIdFromDocument));
        }
        const queryParameters = new URLSearchParams(window.location.search);
        const dealerIdFromQueryParameters = queryParameters.get('partner_id');
        if (dealerIdFromQueryParameters) {
            return resolve(exports.formatID(dealerIdFromQueryParameters));
        }
        const { hash } = window.location;
        const parameter = 'filter=dealer.';
        const dealerIdFromHash = hash.includes(parameter)
            ? hash.slice(hash.indexOf(parameter) + parameter.length)
            : null;
        if (dealerIdFromHash) {
            return resolve(exports.formatID(dealerIdFromHash));
        }
        resolve(null);
    });
});
exports.fetchDealerId = fetchDealerId;
//# sourceMappingURL=fetch-dealer-id.js.map